<header [ngClass]="profileName" id="page-topbar">
  <div class="navbar-header px-0 d-flex flex-column">

    <div class="d-flex justify-content-between w-100">
      <!-- LOGO -->
      <div class="navbar-brand-box px-18px">
        <a class="top-logo logo-light" routerLink="/">
          <span class="logo-sm btn-cursor">
            <img class="logo" src="/assets/img/samsungcare.svg" width="45px">
          </span>
        </a>
      </div>

      <!--      Need Button Design    -->
      <div *ngIf="isConcealedDamage" class="navigate-button-container pl-8px">
        <div>
          <button
            (click)="openPage('')"
            [ngClass]="{'active-navigate-button': pageName === '', 'inactive-navigate-button': pageName !== '', 'navigate-button': true}">
            RA Request
          </button>
        </div>
        <div *ngIf="isAdmin">
          <button
            (click)="openPage('cd-report')"
            [ngClass]="{'active-navigate-button': pageName === 'cd-report', 'inactive-navigate-button': pageName !== 'cd-report', 'navigate-button': true}">
            CD Report
          </button>
        </div>
        <div *ngIf="isAdmin">
          <button
            (click)="openPage('access-data')"
            [ngClass]="{'active-navigate-button': pageName === 'access-data', 'inactive-navigate-button': pageName !== 'access-data', 'navigate-button': true}">
            Access Data
          </button>
        </div>
      </div>

      <div class="dropdown pr-4px d-lg-none d-md-inline-block">
        <button (click)="dropDownToggle()" aria-controls="dropdown-basic"
                class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn" id="page-header-user-dropdown"
                type="button">
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <!--  user info start    -->
      <div class="dropdown d-inline-block pl-20px d-none d-lg-flex justify-content-end w-100 top-lg d-flex align-items-center" dropdown>
        <font-awesome
          *ngIf="isConcealedDamage"
          (click)="showHelpModal()"
          [cssClass]="'font-size-20 text-primary btn-cursor'"
          [icon]="'fa-regular fa-question-circle'"
          class="helpIcon topbar-help-icon">
        </font-awesome>
        <button aria-controls="dropdown-basic" class="btn header-item user text-start d-flex align-items-center"
                dropdownToggle
                type="button">
          <span class="d-none d-sm-block user-item-desc" *ngIf="myInfo?.firstName">
            <dp-avatar [displayType]="'circle'" [naming]="myInfo | displayName" [size]="34"></dp-avatar>
          </span>
        </button>
        <div *dropdownMenu class="dropdown-menu dropdown-menu-end pt-0" style="width: 216px;">
          <div class="p-3 bg-primary border-bottom">
            <h6 *ngIf="myInfo.firstName" class="mb-0 text-white">{{ myInfo | displayName }}</h6>
            <p class="mb-0 font-size-11 text-white-50 fw-semibold">{{ myInfo.username }}</p>
          </div>
          <a (click)="registerMFA()" class="dropdown-item" href="javascript: void(0);">
            <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Register MFA</span>
          </a>
          <a (click)="logout($event)" class="dropdown-item" href="javascript: void(0);">
            <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Logout</span>
          </a>
        </div>
      </div>
      <!--  user info end    -->


    </div>
    <div (clickOutside)="topMenuOutSideClick()"
         *ngIf="isDropDownMenu"
         [delayClickOutsideInit]="true"
         class="w-100">
      <div class="dropdown-menu dropdown-menu-end bg-dark pt-0 color-white show w-100">
        <!--<div class="p-3 bg-primary border-bottom">
          <h6 class="mb-0 text-white" *ngIf="myInfo.firstName">{{myInfo | displayName}}</h6>
          <p class="mb-0 font-size-11 text-white-50 fw-semibold">{{myInfo.username}}</p>
        </div>-->

        <ng-container *ngFor="let item of menuItems">
          <a *ngIf="!hasItems(item) && item?.isLayout" [routerLink]="item.link" class="dropdown-item">
            <font-awesome [icon]="'mr-12px nav-icon fa-regular '+item.icon"></font-awesome>
            <span class="align-middle">{{ item.label | translate }}</span>
          </a>
        </ng-container>

        <a (click)="logout($event)" class="dropdown-item" href="javascript: void(0 );">
          <i class="mdi mdi-logout font-size-16 align-middle mr-12px"></i>
          <span class="align-middle">Logout</span>
        </a>
      </div>
    </div>

  </div>
</header>
